import BaseInput from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const EyeButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const Input = styled(BaseInput)`
  width: 100% !important;
  border-radius: 4px;
  &.error {
    border-color: ${color.sunsetOrange};
    &:not(.ant-input-affix-wrapper-disabled):hover,
    &:not(.ant-input-affix-wrapper-disabled):focus,
    &:not(.ant-input-affix-wrapper-disabled):focus-within {
      border-color: ${color.sunsetOrange};
    }
  }
  &:not(.ant-input-affix-wrapper-disabled):hover,
  &:not(.ant-input-affix-wrapper-disabled):focus,
  &:not(.ant-input-affix-wrapper-disabled):focus-within {
    border-color: ${color.primary};
  }

  input {
    transition: unset;
  }

  input[type='password']:not(:placeholder-shown) {
    letter-spacing: 4px;
  }
`;
